import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Field } from 'src/shared/components/form/field';
import { Switch } from 'src/shared/components/form/switch';
import { FreeSignupAlert } from './freeSignupAlert';
export function FreeModule() {
    const { t } = useTranslation();
    const { register } = useFormContext();
    return (_jsxs(Field, { children: [_jsx(Field.Label, { children: t('modules.form.free_module.label') }), _jsxs("div", { className: "rounded-extralarge border-radius border-small border-neutral-200 px-4 pt-4", children: [_jsx(Switch, { id: "publicModule", ...register('publicModule'), label: t('modules.form.free_module.toggle_label') }), _jsx(FreeSignupAlert, {})] })] }));
}
